import styled from "styled-components";

export const FooterContainerDiv = styled.div`
  .gradient-container {
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0%;
  }
`;
export const FooterStyleMainDiv = styled.footer`
  display: flex;
  padding: 100px 40px 30px;
  justify-content: center;

  > div {
    max-width: 1140px;
    width: 100%;
    flex: 1;
    display: flex;
  }
  .footer-container {
    border-radius: 20px;
    background: black;
    width: 100%;
    flex: 1;
    display: flex;
    flex-flow: column;
  }
  .footer-top-container {
    display: flex;
    padding: 30px 30px 60px;
    flex: 1;
    width: 100%;
    gap: 24px;
    justify-content: space-between;
  }
  .footer-left-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 272px;
  }
  .footer-text-wrapper {
    h4 {
      padding: 0px;
      margin: 0;
      font-size: 32px;
      font-weight: 500;
      line-height: 1.1em;
      font-family: "General Sans", "General Sans Placeholder", sans-serif;
    }

    > p {
      font-family: "Inter", "Inter Placeholder", sans-serif;
      line-height: 1.5em;
      font-size: 18px;
      font-weight: 400;
    }
  }
  .footer-logo-container {
    width: 40px;
    height: 40px;
  }
  .footer-logo-holder {
    display: flex;
    align-items: center;
    text-decoration: none;
    gap: 12px;
  }
  .footer-right-container {
    display: flex;
    gap: 16px;
    max-width: 528px;
    width: 100%;
    flex: 1;
    justify-content: space-between;
  }
  .footer-link-container {
    text-decoration: none;
    font-size: 18px;
    font-weight: 500;
    color: white;
    transition: all 0.4s;
    opacity: 0.7;
    line-height: 1.6em;
    font-family: "Inter", "Inter Placeholder", sans-serif;

    &:hover {
      opacity: 1;
    }
  }
  .footer-links-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .footer-link-header-container {
    opacity: 0.5;

    > p {
      font-size: 18px;

      font-weight: 500;
      font-family: "Inter", "Inter Placeholder", sans-serif;
    }
  }
`;
